import React, { useState, useEffect } from 'react';
import {
  Button,
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  Checkbox,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { useApiClient } from '../../context/apiClient';
import dayjs from 'dayjs'

const IndAvatar = ({member, type}) => {

    const shadeColor = member.gender === "female" ? "#800080" : "blue"
    const fontWeight = type === 'self' || type === "spouse" ? "bold": "regular"
    return (
        <Stack direction="row" alignItems="center" sx={{mr:2}}>
            <Avatar sx={{ boxShadow: `0 0px 10px ${shadeColor}`}} alt={member.firstName} src={member.thumb}/>
            <Typography sx={{ml: 1, fontWeight: fontWeight}}>{member.firstName}</Typography>
        </Stack>
    )
}

const ParentRow = ({parents}) => {
    if (Array.isArray(parents) && parents.length > 0) {
        return (<Stack sx={{width: '100%', mb: 2,  width: "max-content"}} direction="row" alignItems="center" justifyContent="center">
            {parents.map(parent => (<IndAvatar member={parent}/>))}
        </Stack>)
    }
    return(<Stack sx={{width: '100%', mb: 2}} direction="row" alignItems="center" justifyContent="center">
        <Typography>No Parents Added</Typography>
    </Stack>)
}

const SelfRow = ({self, spouse, siblings}) => {

    const getInsertIndex = (array, insertObj) => {
        return array.findIndex(
            p => dayjs(insertObj.dob, "DD/MM/YYYY").isBefore(dayjs(p.dob, "DD/MM/YYYY"))
        );
    }

    siblings = siblings.sort((a, b) => dayjs(a.dob, "DD/MM/YYYY").diff(dayjs(b.dob, "DD/MM/YYYY")))
    let insertIndex = getInsertIndex(siblings, self);
    if (insertIndex === -1) insertIndex = siblings.length;
    const elders = siblings.slice(0, insertIndex)
    const yongers = siblings.slice(insertIndex)

    return (<Stack sx={{width: '100%', mb: 2,  width: "max-content"}}  direction="row" alignItems="center" justifyContent="center">
         {elders.map(sib => (<IndAvatar member={sib}/>))}
         <IndAvatar member={self} type="self"/>
         {spouse.map(sp => (<IndAvatar member={sp} type="spouse"/>))}
         {yongers.map(sib => (<IndAvatar member={sib}/>))}
     </Stack>)
}

const ChildrenRow = ({children}) => {
    children = children.sort((a, b) => dayjs(a.dob, "DD/MM/YYYY").diff(dayjs(b.dob, "DD/MM/YYYY")))
    if (Array.isArray(children) && children.length > 0) {
        return (<Stack sx={{width: '100%', mb: 2,  width: "max-content"}} direction="row" alignItems="center" justifyContent="center">
            {children.map(child => (<IndAvatar member={child}/>))}
        </Stack>)
    }
    return(<Stack sx={{width: '100%', mb: 2}} direction="row" alignItems="center" justifyContent="center">
        <Typography>No Children Added</Typography>
    </Stack>)
}

const Hierarchy = ({open, onClose, userId}) =>{
    const [relatives, setRelatives] = useState()
    const apiClient = useApiClient()

    const fetchRelatives = async (userId) => {
        const data = apiClient.post('/graphql', {"query":"query getUserWithRelations($id: ID!) { getUserWithRelations(id: $id) { children {id firstName thumb gender dob} parents {id firstName thumb gender dob} siblings{id firstName thumb gender dob} spouse{id firstName thumb gender dob} self{id firstName thumb gender dob}} }", variables:{id: userId}})
        .then(response => {
            if (response.data.data && response.data.data.getUserWithRelations) {
                setRelatives(response.data.data.getUserWithRelations)
            }
        })
        .catch(err => console.error(err));
    };
    useEffect(()=>{
        if (userId) {
            fetchRelatives(userId)
        }
    }, [userId])


    if (relatives) {
        return (
            <Dialog open={open} onClose={()=>{ onClose() }} fullWidth>
                <DialogTitle>
                    Hierarchy
                </DialogTitle>
                <DialogContent sx={{pt: '10px!important',  overflowX: "auto", display:'flex', flexDirection: 'column', alignItems: 'center', width: 'max-content' }}>
                    <ParentRow parents={relatives?.parents ?? []}/>
                    <SelfRow self={relatives?.self} siblings={relatives?.siblings} spouse={relatives?.spouse}/>
                    <ChildrenRow children={relatives?.children ?? []}/>
                </DialogContent>
            </Dialog>
        )
    }
    return null
}

export default Hierarchy
